module.exports = __webpack_public_path__ + "static/media/stroopwafel.f5c00469.svg";